import * as React from 'react';
import * as ReactDOM from 'react-dom';
//import * as V from 'victory';
import { App } from 'components/App';
import './theme';
import './index.pcss';

const init = function() {	
	ReactDOM.render(<App />, document.getElementById('body'));
};

init();

